import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./elements/RouteScrollToTop";
import ScrollToTop from "react-scroll-to-top";
import HomeOne from "./pages/HomeOne";
import Home from "./pages/Home";
import HomeThree from "./pages/HomeThree";
import HomeFour from "./pages/HomeFour";
import HomeFive from "./pages/HomeFive";
import SobreNos from "./pages/sobre-nos";
import Servicos from "./pages/Servicos";

// Importando as 5 páginas de serviços que criamos
import ServiceRecrutamento from "./pages/ServiceRecrutamento";
import ServiceHunting from "./pages/ServiceHunting";
import ServiceEquipes from "./pages/ServiceEquipes";
import ServiceRpo from "./pages/ServiceRpo";
import ServiceConsultoria from "./pages/ServiceConsultoria";

import Project from "./pages/Project";
import ProjectDetails from "./pages/ProjectDetails";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import Pricing from "./pages/Pricing";
import Team from "./pages/Team";
import TeamDetails from "./pages/TeamDetails";
import Contato from "./pages/Contato";
import Error from "./pages/Error";

import Faq from "./pages/Faq"
const App = () => {
  return (
    <>
      <BrowserRouter>
        <RouteScrollToTop />
        <ScrollToTop smooth color="#000000" />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/sobre-nos" element={<SobreNos />} />
          <Route exact path="/servicos" element={<Servicos />} />
          
          {/* Rotas específicas para cada serviço (SEO otimizado) */}
          <Route exact path="/recrutamento-e-selecao" element={<ServiceRecrutamento />} />
          <Route exact path="/hunting-especializado" element={<ServiceHunting />} />
          <Route exact path="/estruturacao-de-equipes" element={<ServiceEquipes />} />
          <Route exact path="/rpo-recrutamento" element={<ServiceRpo />} />
          <Route exact path="/consultoria-rh" element={<ServiceConsultoria />} />
          
          
          <Route exact path="/contato" element={<Contato />} />
          <Route exact path="*" element={<Error />} />
          <Route exact path="/faq" element={<Faq />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;